import React, { memo, useEffect, useRef, useState } from 'react';
import Search from './components/Search';
import { Modal, Button } from 'tea-component';
import { useDebounceEffect } from 'ahooks';
import {
  addSeachRecord,
  delSeachRecord,
  seachRecordList,
} from '@/pages/intelligence/services/common';
import { buriedPointSearch } from '@/pages/home/utils/buriedPoint';
import './index.scss';
import { useIntl, useSelector, useDispatch, getLocale } from 'umi';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { RecordItemType } from './type';
let cancelController: AbortController | null = null;

interface CommonGamesSearchProps {
  /** 页面的参数 */
  fetchParams: any;
  /** 表格接口：点击后重新请求表格接口的接口 */
  getTableResultList?: Function;
  /** 接口用的搜索类型--每个页面都有自己的搜索类型;新风格一般用v2开头 */
  searchType: string;
  /** 搜索打点信息 */
  pageLogInfo: { pageId: string; typeId: string };
  // 是否为前端搜索
  isFrontEndSearch?: boolean;
  // 搜索是否高亮关键字,目前此功能未支持
  hightLinghtKeyWord?: boolean;
  placeholder?: React.ReactNode;
  defaultImg?: SVGAElement;
  // 是否清除输入的内容
  initSearchInput?: boolean | string;
  /** 外部同步到搜索框的展示文案（如下钻带入的游戏名） */
  searchDisplayValue?: string;
  // 清除搜索操作函数
  handleClear: Function;
  // 搜索列表时，将后端返回的格式展示为搜索列表需要的格式
  transTableDataForSearch: Function;
  /** 搜索接口：展示在搜索框的列表结果的接口 ,输入文本时会搜索下拉列表的接口*/
  searchListApi: Function;
  useSearchRecentFun?: any;
  // Streaming页面进行清空操作的，TODO 可优化为initSearchInput
  resetSearchType?: boolean;
  recordNodataList?: any[];
  // 是否为自定义渲染
  isCustomRendering?: boolean;
  // 是否往请求接口自动附加searchKey
  isOuterSearchKey?: boolean;
  // 是否使用新接口，即游戏详情要单独接口调用，且使用unified_ids而不是filter_ids
  isUseNewApi?: boolean;
  // 搜索使用的key，不同的页面使用的不同，默认为search_by_name
  searchKey?: string;
  renderComp?: (item: any, Func: any) => React.JSX.Element;
}

function CommonGamesSearch(props: CommonGamesSearchProps) {
  const {
    fetchParams,
    getTableResultList,
    handleClear: handleClearProp = () => console.log /** 清除接口 */,
    searchType: searchTypeProp,
    pageLogInfo,
    isFrontEndSearch,
    // 默认会附加searchKey，这个参数为true的时候不附加
    isOuterSearchKey,
    searchKey = 'search_by_name',
    searchListApi = () => console.log,
    /** 将搜索记录格式转为搜索展示格式 */
    // transRecordDataForSearch = () => console.log,
    /** 将表格的格式转为搜索展示格式  */
    transTableDataForSearch = () => console.log,
    hightLinghtKeyWord = false,
    initSearchInput,
    searchDisplayValue,
    placeholder,
    resetSearchType, // 针对特殊情况,不支持根据下拉选择框动态report,扩展一下
    defaultImg,
    isCustomRendering,
    recordNodataList = [],
    renderComp,
    useSearchRecentFun,
    isUseNewApi = false,
  } = props;

  // console.log('CommonGamesSearch', props);

  const searchType = resetSearchType || `v2-${searchTypeProp || pageLogInfo?.pageId}`;
  const { userInfo } = useSelector((state) => {
    // @ts-ignore
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });

  const [loading, setLoading] = useState(false);
  const [recentRecordList, setRecentRecordList] = useState<any[]>([]);
  const [searchResultList, setSearchResultList] = useState<any[]>([]);
  // 搜索请求接口防抖--用最新的那个返回值
  const inputKey = useRef(0);

  const transRecordDataForSearch = (res: any) => {
    const recordList = res?.data || [];
    if (!Array.isArray(recordList) || !recordList?.length) {
      return [];
    }
    const tranksList: RecordItemType[] = recordList.map((item) => ({
      id: item?.metric_id,
      imgSrc: item?.metric_cover_url,
      lineOneStr: item?.metric_name,
      lineTwoImg:
        item?.country_abbre === 'noCountry'
          ? ''
          : // MarketProfile返回的是国旗在cdn中的url
          item?.country_abbre?.includes('ogdb-cdn')
          ? item?.country_abbre
          : getCountryFlag(item?.country_abbre),
      // imageType: '',
      lineTwoStr: item?.company_name,
      /** 用于Record删除提供id、点击列表获取 */
      metric_id: item?.metric_id,
    }));

    return tranksList;
  };
  useDebounceEffect(
    () => {
      if (userInfo?.userid && searchType) {
        getRecentRecord();
      }
    },
    [userInfo?.userid, resetSearchType, searchType],
    {
      wait: 300,
    },
  );

  /** 搜索历史记录 */
  const getRecentRecord = async () => {
    setLoading(true);
    // setRecentRecordList([]);
    // setSearchResultList([]); //feat 与processRecordList这个函数的冲突异步了
    const params = {
      type: searchType,
      user_id: userInfo?.userid,
    };
    let result = null;
    try {
      // 显式判断 props 中的方法是否存在
      if (typeof useSearchRecentFun === 'function') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        result = await useSearchRecentFun?.(params);
      } else {
        result = await seachRecordList(params);
      }

      /** 对历史记录数据进行处理*/
      const transList = transRecordDataForSearch(result);
      setRecentRecordList(transList);
    } catch (err) {}
    setLoading(false);
  };

  /** 获取搜索结果列表--展示在搜索框 */
  const getSearchResultList = async (inputValue: string) => {
    /** 展示状态： Loading \ 数据 \ 空态 */
    setLoading(true);
    try {
      if (isFrontEndSearch) {
        const transList = transTableDataForSearch(inputValue);
        setSearchResultList(transList);
        setLoading(false);
      } else {
        // 附加search key
        const appendParams = isOuterSearchKey
          ? {}
          : {
              [searchKey]: inputValue,
            };
        const apiCurrent = inputKey.current;
        if (cancelController) {
          cancelController?.abort();
        }
        cancelController = new AbortController();
        let searchParams = {
          ...fetchParams,
          // search_name: inputValue, //旧
          // search_by_name: inputValue, // 新 兼容新旧2种写法，后面可以让后端统一只用一个name
          ...appendParams,
        };
        if (isUseNewApi) {
          searchParams = {
            ...searchParams,
            unified_ids: searchParams?.filter_ids || [],
          };
        }
        const result = await searchListApi(searchParams, { signal: cancelController?.signal });

        if (result?.error && result?.error.msg === 'canceled') return;
        const transList = await transTableDataForSearch(result);
        /** input 输入框频繁请求接口，正确的显示最后一次接口返回的数据 */
        if (apiCurrent === inputKey.current) {
          setSearchResultList(transList);
        }
        setLoading(false);
      }
    } catch (err: any) {
      if (err && err?.msg === 'canceled') return;
      setLoading(false);
    }
  };

  /** 点击搜索结果对应条目展示在表格上 */
  const clickSearchItem = async (type: 'record' | 'search', cvm: RecordItemType) => {
    /** 添加条目到历史记录 */
    if (type !== 'record') {
      addRecordItem(cvm);
    }
    if (getTableResultList instanceof Function) {
      // 其他地方有用到搜索结果的其他参数，一并返回吧
      getTableResultList(cvm?.id, cvm);
    }
  };

  /** 输入搜索关键值 */
  const handleChangeInput = (inputValue: string) => {
    setSearchResultList([]);
    inputKey.current = inputKey.current + 1;
    getSearchResultList(inputValue);
    // 添加搜索打点
    if (pageLogInfo?.pageId) {
      buriedPointSearch({ extInfo: pageLogInfo?.pageId, typeId: pageLogInfo?.typeId }, inputValue);
    }
  };

  /** 点X清除 */
  const handleClear = () => {
    /** 重新展示历史记录 */
    getRecentRecord();
    handleClearProp();
  };

  const addRecordItem = (item: RecordItemType) => {
    if (typeof item !== 'object') {
      return;
    }
    const params = {
      user_id: userInfo?.userid,
      type: searchType,
      metric_id: item.id,
      metric_name: item.lineOneStr,
      metric_cover_url: item.imgSrc,
      company_name: item.lineTwoStr,
      city_name: item.lineTwoStr,
      country_abbre: item?.showImgTwo === false ? 'noCountry' : item.lineTwoImgName,
    };
    addSeachRecord({ add_message: [params] });
  };

  /** 删除某个历史记录 */
  const deleteRecordItem = async (item: any) => {
    if (typeof item !== 'object') {
      return;
    }
    const params = {
      metric_id: item.metric_id,
      user_id: userInfo?.userid,
    };
    let result = null;
    result = await delSeachRecord(params);
    if (result.code === 0) {
      getRecentRecord();
    } else {
      Modal.error({
        message: 'Sorry',
        description: 'Data cannot be deleted !',
        buttons: [<Button type="primary">Got it!</Button>],
        size: 'm',
      });
    }
  };

  return (
    <Search
      loading={loading}
      handleChangeInput={handleChangeInput}
      resetSearchType={resetSearchType}
      recentRecordList={recentRecordList}
      searchResultList={searchResultList}
      initSearchInput={initSearchInput}
      searchDisplayValue={searchDisplayValue}
      placeholder={placeholder}
      handleClear={handleClear}
      clickSearchItem={clickSearchItem}
      deleteRecordItem={deleteRecordItem}
      getRecentRecord={getRecentRecord}
      hightLinghtKeyWord={hightLinghtKeyWord}
      isCustomRendering={isCustomRendering}
      searchType={searchType}
      defaultImg={defaultImg}
      fetchParams={fetchParams}
      recordNodataList={recordNodataList}
      renderComp={renderComp}
    />
  );
}
export default memo(CommonGamesSearch);
